// Create src/components/PageNotFoundHandler.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SessionManager } from '../components/ComponentsLibrary';

const PageNotFoundHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [redirectCountdown, setRedirectCountdown] = useState(3);

  useEffect(() => {
    console.log(`🔍 Invalid page requested: ${location.pathname}`);
    
    // Start countdown for automatic redirect
    const countdownTimer = setInterval(() => {
      setRedirectCountdown(previousCount => {
        if (previousCount <= 1) {
          clearInterval(countdownTimer);
          redirectToPreviousPage();
          return 0;
        }
        return previousCount - 1;
      });
    }, 1000);

    return () => clearInterval(countdownTimer);
  }, []);

  const redirectToPreviousPage = () => {
    try {
      // 🔍 FIXED: Use window.history.back() instead of navigate(-1)
      if (window.history.length > 2) { // Check if there's actual history (more than current page)
        console.log('🔍 Going back using window.history.back()');
        window.history.back();
      } else {
        console.log('🔍 No navigation history - redirecting to default page');
        navigate('/errorFallbackPage', { replace: true });
      }
    } catch (error) {
      console.error('🔍 Error navigating back:', error);
      // Fallback to default page
      navigate('/errorFallbackPage', { replace: true });
    }
  };

  const handleImmediateRedirect = () => {
    redirectToPreviousPage();
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: '50%', 
      left: '50%', 
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#d32f2f',
      color: 'white',
      padding: '30px 40px',
      borderRadius: '12px',
      textAlign: 'center',
      zIndex: 9999,
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      minWidth: '400px'
    }}>
      <h2 style={{ margin: '0 0 15px 0', fontSize: '24px' }}>
        Page Not Available
      </h2>
      <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
        The requested path <code style={{ 
          backgroundColor: 'rgba(255,255,255,0.2)', 
          padding: '2px 6px', 
          borderRadius: '4px' 
        }}>
          {location.pathname}
        </code> could not be found.
      </p>
      <p style={{ margin: '0 0 25px 0', fontSize: '16px' }}>
        Automatic redirect in <strong>{redirectCountdown}</strong> second{redirectCountdown !== 1 ? 's' : ''}...
      </p>
      
      <button 
        onClick={handleImmediateRedirect}
        style={{
          backgroundColor: 'white',
          color: '#d32f2f',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '14px',
          transition: 'opacity 0.2s'
        }}
        onMouseOver={(e) => e.target.style.opacity = '0.8'}
        onMouseOut={(e) => e.target.style.opacity = '1'}
      >
        Return Now
      </button>
    </div>
  );
};

export default PageNotFoundHandler;